import { usePathname, useRouter } from "next/navigation";
import { useEffect, useTransition } from "react";
import { AccessMenuType } from "./types";
import { AccessEnum } from "@/widgets/Sidebar/types";
import { authStore } from "@/shared/store/authStore/authStore";

export function useUserAccess(requiredAccess: AccessEnum[]){
  const router = useRouter();
  const userRole = authStore.state.userInfo?.roleId as AccessEnum;

  useEffect(() => {
    const hasAccess = requiredAccess.includes(userRole);
    
    if (!hasAccess) {
      router.push('/empty');
    }
  }, [userRole, requiredAccess, router]);

  return {
    hasAccess: requiredAccess.includes(userRole || AccessEnum.NO_ROLE),
    userRole
  };
}

const ACCESS_MENU: AccessMenuType[] = [
  {
    id: '1',
    pathname: '/archive',
    access: [AccessEnum.ADMIN, AccessEnum.USER]
  },
  {
    id: '2',
    pathname: '/access',
    access: [AccessEnum.ADMIN, AccessEnum.LOCAL_ADMIN]
  },
  {
    id: '3',
    pathname: '/basket',
    access: [AccessEnum.ADMIN, AccessEnum.USER]
  },
  {
    id: '4',
    pathname: '/docs',
    access: [AccessEnum.ADMIN, AccessEnum.USER]
  },
  {
    id: '5',
    pathname: '/favorites',
    access: [AccessEnum.ADMIN, AccessEnum.USER]
  },
  {
    id: '6',
    pathname: '/search',
    access: [AccessEnum.ADMIN]
  },
  {
    id: '7',
    pathname: '/sessions',
    access: [AccessEnum.ADMIN, AccessEnum.USER]
  },
  {
    id: '8',
    pathname: '/sources',
    access: [AccessEnum.ADMIN]
  },
  {
    id: '9',
    pathname: '/template',
    access: [AccessEnum.ADMIN]
  },
  {
    id: '10',
    pathname: '/empty',
    access: [AccessEnum.ADMIN, AccessEnum.USER, AccessEnum.NO_ROLE, AccessEnum.LOCAL_ADMIN]
  },
];

export const getAccessByPathname = (pathname: string): AccessEnum[] => {
  const menuItem = ACCESS_MENU.find(item => {
    const pathRegex = new RegExp(`^${item.pathname}(\\/|$)`);
    return pathRegex.test(pathname);
  });
  return menuItem?.access || [AccessEnum.ADMIN]; 
};
